<template>
  <div style="height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 90%; height: 40px">
        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
          <el-input v-model="formDatas.orderPhone" style="width: 180px;" size="mini" placeholder="手机号"
            clearable></el-input>
          <el-input v-model="formDatas.orderNo" style="width: 180px;" size="mini" placeholder="订单号"
            clearable></el-input>
          <el-input v-model="formDatas.couponSn" style="width: 150px; margin-left: 10px;" size="mini" placeholder="券码"
            clearable></el-input>
          <el-select size="mini" v-model="formDatas.abbStatusHexiao" clearable placeholder="核销状态"
            style="width: 130px; margin-left: 10px">
            <el-option label="待核销" :value="1" key="1"></el-option>
            <el-option label="已核销" :value="2" key="2"></el-option>
            <el-option label="已退款" :value="3" key="3"></el-option>
            <el-option label="退款失败" :value="4" key="4"></el-option>
          </el-select>
          <el-select size="mini" v-model="formDatas.abbStatusCreate" clearable placeholder="创建状态"
            style="width: 130px; margin-left: 10px">
            <el-option label="成功" :value="1" key="1"></el-option>
            <el-option label="失败" :value="2" key="2"></el-option>
          </el-select>
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="margin-left: 10px">搜索</el-button>
          <el-button type="warning" size="mini" style="margin-left: 10px" @click="handleExport">导出</el-button>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAjefBillBeiguoList, updateAjefBillBeiguoRefund, getAjefBillBeiguoOneCheck } from "../../api/api";
import axios from 'axios';
import qs from "qs";
import config from "../../api/env.js";
export default {
  name: "",
  components: {},
  data() {
    return {
      tableLoading: false,
      loadings: null,
      totalCount: 100,
      tableHight: 520,
      tableData: [],
      formDatas: {
        orderNo: '',
        couponSn: '',
        abbStatusHexiao: '',
        abbStatusCreate: '',
        currentPage: 1,
        pageSize: 10
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "orderNo",
          key: "orderNo",
          title: "订单号",
          width: 280,
          align: "center",
        },
        {
          field: "couponSn",
          key: "couponSn",
          title: "券码",
          width: 200,
          align: "center",
        },
        {
          field: "orderPhone",
          key: "orderPhone",
          title: "手机号",
          width: 200,
          align: "center",
        },
        {
          field: "abbResult",
          key: "abbResult",
          title: "券码信息",
          align: "center",
          width: 380,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if (!row.abbResult) return '-';
            try {
              const result = JSON.parse(row.abbResult);
              const data = result.data || {};
              const couponSn = data.coupon && data.coupon[0] ? data.coupon[0].coupon_sn : '-';
              return h('div', { style: { fontSize: '12px', lineHeight: '1.6' } }, [
                h('div', [`余额: ${data.balance || '-'}`]),
                h('div', [`北国订单号: ${data.biz_orderno || '-'}`]),
                h('div', [`北国编码: ${couponSn}`])
              ]);
            } catch (e) {
              return '-';
            }
          },
        },
        {
          field: "abbBalance",
          key: "abbBalance",
          title: "券码金额",
          width: 90,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.abbBalance ? (row.abbBalance / 100).toFixed(2) + '元' : '-';
          },
        },
        {
          field: "abbStatusCreate",
          key: "abbStatusCreate",
          title: "创建状态",
          width: 80,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const statusMap = { 1: { text: '成功', type: 'success' }, 2: { text: '失败', type: 'danger' } };
            const status = statusMap[row.abbStatusCreate];
            if (status) {
              return h('el-tag', { props: { type: status.type, size: 'mini' } }, status.text);
            }
            return '-';
          },
        },
        {
          field: "abbStatusHexiao",
          key: "abbStatusHexiao",
          title: "核销状态",
          width: 90,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const statusMap = {
              1: { text: '待核销', type: 'warning' },
              2: { text: '已核销', type: 'success' },
              3: { text: '已退款', type: 'info' },
              4: { text: '退款失败', type: 'danger' }
            };
            const status = statusMap[row.abbStatusHexiao];
            if (status) {
              return h('el-tag', { props: { type: status.type, size: 'mini' } }, status.text);
            }
            return '-';
          },
        },
        {
          field: "abbStatusYd",
          key: "abbStatusYd",
          title: "权益金状态",
          width: 90,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const statusMap = {
              1: { text: '已扣减', type: 'warning' },
              2: { text: '已回退', type: 'success' },
              3: { text: '回退失败', type: 'danger' }
            };
            const status = statusMap[row.abbStatusYd];
            if (status) {
              return h('el-tag', { props: { type: status.type, size: 'mini' } }, status.text);
            }
            return '-';
          },
        },
        {
          field: "abbStatusHy",
          key: "abbStatusHy",
          title: "是否还原订单",
          width: 90,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const statusMap = { 1: { text: '否', type: 'info' }, 2: { text: '是', type: 'success' } };
            const status = statusMap[row.abbStatusHy];
            if (status) {
              return h('el-tag', { props: { type: status.type, size: 'mini' } }, status.text);
            }
            return '-';
          },
        },
        {
          field: "abbStausBeiguo",
          key: "abbStausBeiguo",
          title: "北国状态核查",
          width: 90,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const statusMap = { 1: { text: '否', type: 'info' }, 2: { text: '是', type: 'success' } };
            const status = statusMap[row.abbStausBeiguo];
            if (status) {
              return h('el-tag', { props: { type: status.type, size: 'mini' } }, status.text);
            }
            return '-';
          },
        },
        {
          field: "abbStausBeiguoTime",
          key: "abbStausBeiguoTime",
          title: "核查时间",
          width: 170,
          align: "center",
        },
        {
          field: "abbStausBeiguoText",
          key: "abbStausBeiguoText",
          title: "核查记录",
          width: 280,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if (!row.abbStausBeiguoText) return '-';
            try {
              const data = JSON.parse(row.abbStausBeiguoText);
              return h('div', { style: { fontSize: '12px', lineHeight: '1.6', textAlign: 'left' } }, [
                h('div', [`商品名称: ${data.usedesc || '-'}`]),
                h('div', [`使用状态: ${data.used_status || '-'}`]),
                h('div', [`使用时间: ${data.used_time || '-'}`])
              ]);
            } catch (e) {
              return '-';
            }
          },
        },
        {
          field: "createtime",
          key: "createtime",
          title: "创建时间",
          width: 170,
          align: "center",
        },
        {
          field: "action",
          key: "action",
          title: "操作",
          width: 130,
          align: "center",
          fixed: 'right',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const buttons = [];
            // 退款按钮
            if (row.abbStatusHexiao === 1 || row.abbStatusHexiao === 4) {
              buttons.push(h('el-button', {
                props: { type: 'text', size: 'mini' },
                style: { color: '#F56C6C', padding: '0 5px' },
                on: { click: () => this.handleRefund(row) }
              }, '退款'));
            }
            // 状态核查按钮
            buttons.push(h('el-button', {
              props: { type: 'text', size: 'mini' },
              style: { color: '#409EFF', padding: '0 5px' },
              on: { click: () => this.handleCheck(row) }
            }, '核查'));
            return h('div', { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } }, buttons);
          },
        },
      ],
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
    };
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      getAjefBillBeiguoList(this.formDatas).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
    handleRefund(row) {
      this.$confirm('确定要退款吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.openLoading()
        updateAjefBillBeiguoRefund({ abbId: row.abbId }).then((res) => {
           this.loadings.close()
          this.$message.success('退款成功');
          this.getList();
        }).catch(() => {
          this.$message.error('退款失败');
        });
      }).catch(() => { });
    },
    handleCheck(row) {
      this.$confirm('确定要进行状态核查吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        getAjefBillBeiguoOneCheck({ abbId: row.abbId }).then((res) => {
          this.$message.success('核查成功');
          this.getList();
        }).catch(() => {
          this.$message.error('核查失败');
        });
      }).catch(() => { });
    },
    handleExport() {
      const params = {
        orderNo: this.formDatas.orderNo,
        couponSn: this.formDatas.couponSn,
        abbStatusHexiao: this.formDatas.abbStatusHexiao,
        abbStatusCreate: this.formDatas.abbStatusCreate
      };
      const s = qs.stringify(params);
      this.openLoading();
      axios({
        method: 'post',
        url: config.baseURL + '/ajef-bill-beiguo/exportAjefBillBeiguo',
        data: s,
        timeout: 1200000,
        responseType: 'arraybuffer',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          'useref': window.localStorage.getItem('Qy_token')
        }
      }).then((res) => {
        if (res.data) {
          this.loadings.close();
          const a = document.createElement('a');
          const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
          const objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", '北国超市订单记录.xlsx');
          a.click();
          this.$message.success('导出成功');
        }
      }).catch(() => {
        this.loadings.close();
        this.$message.error('导出失败');
      });
    },
    openLoading() {
      this.loadings = this.$loading({
        lock: true,
        text: "导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
  },
};
</script>

<style scoped></style>
